export enum MarkingPeriod {
	Current = 'Current',
	All = 'All',
}
